import { CART_MODULE } from "@/api_framework/api_config";
import { ICartCalloutResponse, ICartCalloutResponseData } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useCartCalloutAPI = () => {
  const configuration = useConfiguration();
  const [data, setData] = useState<ICartCalloutResponseData>({ callouts: [] });
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (userId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: AxiosResponse<ICartCalloutResponse> = await axios.get(
          `${CART_MODULE?.CART_CALLOUTS?.baseURL}?user_id=${userId}`,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (response.data.status === true) {
          setData(response.data.data);
        } else {
          setData({ callouts: [] });
          toast.error(response.data.message);
        }
      } catch (e) {
        // captureError(e);
      }
    },
    [configuration, dispatch, sendCurl],
  );

  return { data, execute };
};
